import { OnCloseInlineComposeActionName } from 'owa-mail-compose-action-names';
import { action } from 'satcheljs/lib/legacy';
export default action(OnCloseInlineComposeActionName)(function onCloseInlineCompose(conversationId, inlineComposeParentTabId) {
    // No-op
    // This is called to raise a stitch set up by owa-mail-reading-pane
});
//# sourceMappingURL=onCloseInlineCompose.js.map